import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { formatting } from "@/lib/formatting";

// YTD revenue + commission headline numbers above the tier progress bar
export const EarningsTotalsSnapshot = ({
  totalCommissionDollars,
  totalRevenueDollars,
}: {
  totalCommissionDollars: number;
  totalRevenueDollars: number;
}) => {
  /* Render */
  const render = () => (
    <Row className="items-start justify-between gap-4">
      <Row className="min-w-0 flex-wrap items-start gap-8">
        <Column className="min-w-0 gap-0.5 pr-6">
          <Text className="text-xs font-medium text-slate-500">
            Total revenue YTD
          </Text>
          <Text className="text-[28px] font-medium tabular-nums leading-none text-slate-900">
            {formatting.currency(totalRevenueDollars)}
          </Text>
        </Column>
        <Column className="min-w-0 gap-0.5 pr-6">
          <Text className="text-xs font-medium text-slate-500">
            Total commission YTD
          </Text>
          <Text className="text-[28px] font-medium tabular-nums leading-none text-green-700">
            {formatting.currency(totalCommissionDollars)}
          </Text>
        </Column>
      </Row>
      <Column className="items-end justify-end self-stretch">
        <Text className="text-right text-xs font-medium text-slate-500">
          {new Date().getFullYear().toString()} tier progress
        </Text>
      </Column>
    </Row>
  );

  return render();
};
